import React from 'react'
import Distinct from '../Images/Distinct.png'
import Solve from '../Images/Solve.png'
import Schedule from '../Images/Schedule.png'
import { Link } from 'react-router-dom'

export default function TailwindSection() {
    return (
        <section className="text-gray-600 body-font">
            <div className="container px-5 py-24 mx-auto">
                <h1 className="sm:text-3xl text-2xl font-medium title-font text-center text-gray-900 mb-20">Ultimate Features Provided By
                    <br className="hidden sm:block" />Ganitagya Classes
                </h1>
                <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
                    <div className="p-4 md:w-1/3 flex">
                        <div className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-4 flex-shrink-0">
                            <img src={Distinct} alt="" />
                        </div>
                        <div className="flex-grow pl-6">
                            <h2 className="text-gray-900 text-lg title-font font-medium mb-2">Distinct Courses</h2>
                            <p className="leading-relaxed text-base">We offer a diverse selection of distinct courses tailored to cater to various interests and skill levels. Our courses aim to provide comprehensive learning opportunities for everyone.</p>
                            <Link to='/courses' className="mt-3 text-indigo-500 inline-flex items-center">Go through
                                <svg htmlfill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </Link>
                        </div>
                    </div>
                    <div className="p-4 md:w-1/3 flex">
                        <div className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-4 flex-shrink-0">
                            <img src={Solve} alt="" />
                        </div>
                        <div className="flex-grow pl-6">
                            <h2 className="text-gray-900 text-lg title-font font-medium mb-2">Doubt Solving Section</h2>
                            <p className="leading-relaxed text-base">Solve your Doubts at a professional level with assistance of highly programmed AI technology. Just ask your doubts smartly mentioning desired prompts. Clear your doubts now !</p>
                            <Link to='/ask' className="mt-3 text-indigo-500 inline-flex items-center">Go through
                                <svg htmlfill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </Link>
                        </div>
                    </div>
                    <div className="p-4 md:w-1/3 flex">
                        <div className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-4 flex-shrink-0">
                            <img src={Schedule} alt="" />
                        </div>
                        <div className="flex-grow pl-6">
                            <h2 className="text-gray-900 text-lg title-font font-medium mb-2">Detailed Schedule</h2>
                            <p className="leading-relaxed text-base">Our schedules are designed to accommodate busy lifestyles, with flexible options that allow you to learn at your own pace and convenience. Take a look at your easy-peasy schedule.</p>
                            <Link to='/schedule' className="mt-3 text-indigo-500 inline-flex items-center">Go through
                                <svg htmlfill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
